import {React,useState,useEffect} from 'react'
import { addAUser, deleteUser, editUser, getUsers } from '../configurations/apiconfig';
import '../App.css'
import NavBar from '../components/NavBar';
import { ToastContainer, toast } from 'react-toastify';
const UserManagement = () =>
{
  const [data,setData]=useState([]);
  const [role,setRoleData]=useState([]);
  const [isUpdate,setIsUpdate]=useState(false);
  const notify = () => toast("Wow so easy!");
  const [addUser,setAddUser]=useState({id:0,name:"",contact:"",email:"",password:"",role_id:"",created_by:localStorage.getItem("id")});
    const handleInputChange=(e)=>{
        const name=e.target.name;
        const value=e.target.value;

        setAddUser((prev)=>
        {
            return{...prev,[name]:value,}
        })
    };

    const addUserData= async ()=>
    {
      console.log("22");
                if(isUpdate)
                {
                  console.log("ID is there:"+addUser.id);
                  const res=await editUser(addUser)
              if((res.status===200))
                {
                  console.log("66");
                    setAddUser({name:"",contact:"",email:"",password:"",role_id:"",created_by:localStorage.getItem("id")})
                    toast.warn("User Updated!");  
                    //setData([])
                }
                getUserData();
                setIsUpdate(false);
                }
                else
                {
                      console.log("55");
                      console.log("ID is there:"+addUser.name);
                      const res=await addAUser(addUser);
                  if((res.status===200))
                    {
                      console.log("66");
                        setAddUser({name:"",contact:"",email:"",password:"",role_id:"",created_by:localStorage.getItem("id")})
                        toast.success("User Created!");
                        //setData([])
                    }
                    getUserData();
                }
                console.log("77");
    //     const res=await addAUser(addUser);
    //     console.log("res",res);

    // if((res.status===200))
    // {
    //     setAddUser({title:"",description:"",time_line:""})
    //     //setData([])
    // }
    }

    const handleFormSubmit=(e)=>
    {
        e.preventDefault();
        addUserData();
    }

    const clearForm=()=>
    {
        setAddUser({title:"",description:"",time_line:""});
    }
    
    useEffect(()=>
    {
        getUserData();
    },[]);

    const getUserData=async()=>
    {
        const res=await getUsers();
        setData(res.data["user_list"]);
        setRoleData(res.data["rolelist"]);
        console.log(res.data["rolelist"])
    }

    const handleClickDelete= async(id)=>
    {
        //console.log("me to chals"+id);
        try
        {
            const res=await deleteUser(id);
            if(res.status===200)
            {
                
            }
        }catch(error)
        {

        }
    }

    const handleClickEdit= async(currentElement)=>
    {
        console.log(currentElement.task_description+"me to chals"+currentElement.role_id);
        try
        {
          setAddUser({
            id:currentElement.id
            ,name:currentElement.name
            ,contact:currentElement.contact
            ,email:currentElement.email
            ,password:currentElement.password
            ,role_id:currentElement.role_id
            });
            setIsUpdate(true);
        }catch(error)
        {

        }
    }

const [navbar,setNavigationBar]=useState(true);
  return (
      <>{navbar==true?<NavBar userType={localStorage.getItem("role_id")}/>:<></>}
<section className="management-section container-fluid">
<div className="row g-4">
 <div className="col-md-4">
  <div className="card p-4 text-start">
    <h4 className="mb-3">Add User</h4>
    
     <form className="" onSubmit={handleFormSubmit}>
      <div className="mb-3">
        <label className="form-label">Name</label>
        <input type="text" className="form-control" placeholder="Enter title" name="name" id="name" value={addUser.name} onChange={handleInputChange}/>
      </div>
      <div className="mb-3">
        <label className="form-label">Contact</label>
        <input type="text" className="form-control" placeholder="Enter time line" name="contact" id="contact" value={addUser.contact} onChange={handleInputChange}/>
      </div>
      <div className="mb-3">
        <label className="form-label">Email</label>
        <input type="text" className="form-control" placeholder="Enter time line" name="email" id="email" value={addUser.email} onChange={handleInputChange}/>
        
        </div>

        <div className="mb-3">
        <label className="form-label">Password</label>
        <input type="text" className="form-control" placeholder="Enter Password" name="password" id="password" value={addUser.password} onChange={handleInputChange}/>
        
        </div>

        <div className="mb-3">
            <label className="form-label">Role</label>
            <select className="form-select"
            name="role_id"
            id="role_id"
            value={addUser.role}
            onChange={handleInputChange}
            >
              <option selected disabled>Choose Role</option>
{role.map((currentElement)=>{
  return <option value={currentElement.id} selected={currentElement.id==addUser.role_id?true:false} key={currentElement.id}>{currentElement.title}</option>
})}
              {/* <option>1</option>
              <option>2</option>
              <option>3</option>
              <option>4</option> */}

            </select>
          </div>

          {isUpdate?
      <button type="submit" className="btn btn-warning w-100">Update</button>:
      <button type="submit" className="btn btn-primary w-100">Add New</button>} 
    </form>

  </div>
</div>

<div className="col-md-8">
<ToastContainer />
  <div className="card p-3">
    <h4 className="mb-3">User Details</h4>
    <div className="table-responsive">
      <table className="table table-bordered table-striped align-middle">
        <thead>
          <tr>
            <th>id</th>
            <th>Name</th>
            <th>Contact</th>
            <th>Email</th>
            <th>Role</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
        {data.map((currentElement)=>
    {
        return(<tr key={currentElement.id}>
            <td>{currentElement.id}</td>
            <td>{currentElement.name}</td>
            <td>{currentElement.contact}</td>
            <td>{currentElement.email}</td>
            <td>{currentElement.title}</td>
            <td><button className="btn btn-success" onClick={()=>handleClickEdit(currentElement)}>Update</button> <button className="btn btn-danger" onClick={()=>handleClickDelete(currentElement.id)}>Delete</button></td>
          </tr>)
    })}
        </tbody>
      </table>
    </div>
  </div>
</div>



</div>
</section>
</>
)
}

export default UserManagement
